import { TextField as MUITextField } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import { useState } from 'react'
import { useNotify, useRefresh } from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { removeEquipment } from '../../api/core'

export const RemoveEquipmentButton = ({ record, permissions, equipmentType }: any) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState(false)
  const [removalReason, setRemovalReason] = useState('')

  if (!record || !permissions) {
    return null
  }

  const onClick = () => {
    setOpen(false)
    removeEquipment(record.id, removalReason, equipmentType)
      .then(() => {
        refresh()
        notify('Successfully removed!', { type: 'success' })
      })
      .catch((error) => {
        notify(error.message, { type: 'error' })
        captureExceptionIfProduction(error)
      })
      .finally(() => {
        setOpen(false)
      })
  }

  const handleChange = (event: any) => {
    setRemovalReason(event.target.value)
  }

  return (
    <div>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Remove
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Remove Equipment from Fleet</DialogTitle>
        <DialogContent>
          <DialogContentText>This will remove the equipment from the fleet. Are you sure?</DialogContentText>
          <FormControl component="fieldset">
            <MUITextField
              id="outlined-multiline-static"
              label="Removal reason"
              required
              multiline
              fullWidth
              value={removalReason}
              rows={4}
              placeholder="Enter reason"
              variant="outlined"
              onChange={handleChange}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={onClick}>
            Confirm
          </Button>
          <Button color="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
